import { useComingSoonModal } from "@/app/hooks/use_coming_soon"
import { useSelector } from "@/app/providers/selector_provider"
import { FEATURE_FLAG_KEYS } from "@/app/types/flag_definitions"
import { Button } from "@/components/buttons/button"
import { useGrowthBook } from "@growthbook/growthbook-react"
import { EnvelopeSimple, SignOut } from "@phosphor-icons/react"
import { useRouter } from "next/router"

export function UserMenuFooter() {
  const { push } = useRouter()
  const { showSelector } = useSelector()

  const growthbook = useGrowthBook()

  const { openModal, ComingSoonModal } = useComingSoonModal()

  return (
    <>
      <ComingSoonModal message="This feature will allow you to invite others to Grafiniti!" />
      <footer className="mt-3 flex w-full flex-col items-center justify-between gap-2">
        <div className="flex w-full gap-2 px-2">
          <Button
            onClick={() => {
              showSelector(null)
              push("/logout")
            }}
            className="flex items-center gap-1"
            color="primary">
            <SignOut />
            Logout
          </Button>

          {growthbook.isOn(FEATURE_FLAG_KEYS.features.SHOW_INVITE_BUTTON) && (
            <Button
              onClick={() => {
                openModal()
              }}
              className="flex items-center gap-1"
              color="tertiary">
              <EnvelopeSimple />
              Invite
            </Button>
          )}
        </div>
        <div className="flex w-full flex-wrap items-center justify-evenly gap-5 rounded-b-lg bg-main-100 px-2 py-3 text-sm">
          <div
            onClick={() => {
              showSelector(null)
              push("/policies/privacy")
            }}
            className="cursor-pointer duration-300 hover:text-main-500">
            Privacy Policy
          </div>
          <div
            onClick={() => {
              showSelector(null)
              push("/policies/service")
            }}
            className="cursor-pointer duration-300 hover:text-main-500">
            Terms of Service
          </div>
          <div>&copy; 2025 Grafiniti</div>
        </div>
      </footer>
    </>
  )
}
